import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import notification from "@app/services/notification";
import {
    usePerformBoOperationMutation,
    type PerformBoOperationVariables,
} from "@src/businessModules/WorkShop/shared/bo/usePerformBoOperationMutation";
import { wsInvActsServices } from "../../../../api/wsInvActs";

export interface SetFactQtyMutationVariables {
    contentCode: number;
    initialFactQty: number;
    factQty: number;
}

export interface UseWsInvActCardMutationsParams {
    /**
     * Патч `FactQty` обновлённой строки после setFactQty.
     * @param contentCode код строки состава АИ
     * @param factQty фактическое количество, возвращённое API
     */
    onContentFactQtyPatch?: (contentCode: number, factQty: number) => void;
    onBoOperationSuccess?: () => void;
}

export interface UseWsInvActCardMutationsResult {
    setFactQtyMutation: UseMutationResult<number, Error, SetFactQtyMutationVariables>;
    performBoOperationMutation: UseMutationResult<void, Error, PerformBoOperationVariables>;
}

/**
 * Screen-level мутации карточки АИ УП.
 */
export function useWsInvActCardMutations({
    onContentFactQtyPatch,
    onBoOperationSuccess,
}: UseWsInvActCardMutationsParams): UseWsInvActCardMutationsResult {
    const setFactQtyMutation = useMutation({
        mutationKey: ["workshop", "wsInvAct", "content", "setFactQty"],
        meta: { errorSource: "workshop.wsInvAct.content.setFactQty" },
        mutationFn: (variables: SetFactQtyMutationVariables) => wsInvActsServices.content.setFactQty({ data: variables }),
        onSuccess: (newFactQty, variables) => {
            if (newFactQty !== variables.factQty) {
                notification.warning(
                    `Пока вы работали данные были изменены. Данные были синхронизированы.\nФакт кол-во обновлено до ${newFactQty}`,
                );
            }

            onContentFactQtyPatch?.(variables.contentCode, newFactQty);
        },
    });

    const performBoOperationMutation = usePerformBoOperationMutation({
        scope: "wsInvAct",
        onSuccess: onBoOperationSuccess,
    });

    return { setFactQtyMutation, performBoOperationMutation };
}
